import { supabase } from '@/lib/supabase';

interface MediaUrlSource {
  storage_path: string;
  storage_provider?: string | null;
  object_key?: string | null;
  metadata?: unknown;
}

/** true apenas para http/https — bloqueia esquemas como javascript: em valores vindos de metadata gravado pelo cliente. */
function isHttpUrl(value: string): boolean {
  try {
    const { protocol } = new URL(value);
    return protocol === 'http:' || protocol === 'https:';
  } catch {
    return false;
  }
}

/** URL pública de um objeto no bucket `media` (público, leitura sem auth). */
export function getMediaPublicUrl(source: string | MediaUrlSource): string {
  if (typeof source !== 'string' && source.storage_provider === 'r2') {
    const metadata = source.metadata && typeof source.metadata === 'object' ? source.metadata as Record<string, unknown> : {};
    const envPublicBaseUrl = import.meta.env.VITE_R2_PUBLIC_BASE_URL as string | undefined;
    const metadataBaseUrl = typeof metadata.r2_public_base_url === 'string' ? metadata.r2_public_base_url : undefined;
    const publicBaseUrl = metadataBaseUrl && isHttpUrl(metadataBaseUrl) ? metadataBaseUrl : envPublicBaseUrl;
    const objectKey = source.object_key ?? source.storage_path;
    if (publicBaseUrl && isHttpUrl(publicBaseUrl) && objectKey) return `${publicBaseUrl.replace(/\/$/, '')}/${objectKey}`;
  }

  const storagePath = typeof source === 'string' ? source : source.storage_path;
  return supabase.storage.from('media').getPublicUrl(storagePath).data.publicUrl;
}
